let $window = $(window);
let $document = $(document);
let $body = $('body');
let $header = $('.header');
let $burger = $header.find('.header__burger');
let $progerss = $header.find('.header__progress');

let windowHeight = $window.height();
let documentHeight = $document.height() - windowHeight;
let resizeTimeout = 0;
let lockTimeout = 0;

function lockScroll(lock) {
	if (lock) {
		$window.data('scrollPosition', $window.scrollTop());
		$body.addClass('no-scroll');
	} else {
		$body.removeClass('no-scroll');
		$window.scrollTop($window.data('scrollPosition'));
	}
}

function setScrolledState() {
	let scrollTop = $window.scrollTop();
	let isActive = $header.hasClass('is-active');

	if (scrollTop > 50 && !isActive) {
		$header.addClass('is-scrolled');
	} else if (scrollTop <= 50 && !isActive) {
		$header.removeClass('is-scrolled');
	}
}

function setScrollProgress() {
	if ($header.hasClass('is-active')) {
		return;
	}

	let progress = $window.scrollTop() / documentHeight;

	$progerss.css('transform', `scaleX(${progress})`);
}

function deactivate() {
	lockScroll(false);

	$header.removeClass('is-active');
}

function init() {
	windowHeight = $window.height();
	documentHeight = $document.height() - windowHeight;

	setScrolledState();
	setScrollProgress();

	$burger.on('click', () => {
		if ($header.hasClass('is-active')) {
			deactivate();

			return;
		}

		$header.addClass('is-active');

		if (lockTimeout) {
			clearTimeout(lockTimeout);
		}

		lockTimeout = setTimeout(() => {
			lockScroll($header.hasClass('is-active'));
		}, 750);
	});

	$window
		.on('scroll', () => {
			if ($window.width() > 1024) {
				return;
			}

			setScrolledState();
			setScrollProgress();
		})
		.on('resize', () => {
			if (resizeTimeout) {
				clearTimeout(resizeTimeout);
			}

			resizeTimeout = setTimeout(() => {
				windowHeight = $window.height();
				documentHeight = $document.height() - windowHeight;

				setScrolledState();
				setScrollProgress();
			}, 500);
		});
}

export default {
	init,
	deactivate,
};
